/* eslint-disable no-param-reassign */
// eslint-disable-next-line @typescript-eslint/no-unused-vars,prettier/prettier
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isFetching: false,
  isFetchingCount: 0,
  isTyping: false,
  isWaiting: false,
  messages: null,
  typingMessageId: null,
  socketStatus: '',
  isClosedSockets: false,
  isOpenedSockets: false,
  isProcessing: false,
  tooltipId: null,
  convertedText: null,
  checking: false,
  tokens: null,
  channels: [],
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    startFetching(state) {
      state.isFetchingCount += 1;
    },
    stopFetching(state) {
      state.isFetchingCount = Math.max(0, state.isFetchingCount - 1);
    },
    startChecking(state) {
      state.checking = true;
    },
    stopChecking(state) {
      state.checking = false;
    },
    setClosedSockets(state, action) {
      state.isClosedSockets = action.payload;
    },
    setOpenedSockets(state, action) {
      state.isOpenedSockets = action.payload;
    },
    setSocketsStatus(state, action) {
      state.socketStatus = action.payload;
    },
    startTyping(state) {
      state.isTyping = true;
    },
    stopTyping(state) {
      state.isTyping = false;
      state.typingMessageId = null;
    },
    startWaiting(state) {
      state.isWaiting = true;
    },
    stopWaiting(state) {
      state.isWaiting = false;
    },
    startIsImageLoading(state) {
      state.isImageLoading = true;
    },
    fillChannels(state, action) {
      state.channels = action.payload;
    },
    setMessageId(state, action) {
      state.typingMessageId = action.payload;
    },
    fillMessages(state, action) {
      state.messages = action.payload;
    },
    fillUserMessage(state, action) {
      state.isTyping = true;
      state.messages.push(action.payload);
    },
    createMessage(state, action) {
      state.messages.push(action.payload);
    },
    updateMessage(state, action) {
      state.messages = state.messages.map((message) => {
        if (message.id === action.payload.id) {
          return {
            ...message,
            nextToken: action.payload.nextToken,
            tokenIndex: action.payload.tokenIndex,
            text: message.text + action.payload.text,
          };
        }

        return message;
      });
    },
    fillTokens(state, action) {
      state.tokens = action.payload;
    },
    clearMessages(state) {
      state.messages = null;
    },
    deleteUserMessageById(state, action) {
      if (Array.isArray(state.messages)) {
        state.messages = state.messages.filter(m => m.id !== action.payload);
      }
    },
    // INJECT
  },
});

export default chatSlice;
